import { createMiddleware } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";

/**
 * Public marketing pages are fully static (no per-user data is rendered on the
 * server), so let the CDN cache the SSR HTML at the edge. This removes the
 * ~800ms Worker render from TTFB for most visitors, which directly improves
 * FCP/LCP on mobile.
 *
 * Anything under /tools, /inventory, /estimator, /api, etc. stays private.
 */
const PRIVATE_PREFIXES = [
  "/tools",
  "/inventory",
  "/estimator",
  "/blueprint-counter",
  "/sold-homes",
  "/api",
  "/lovable",
  "/email",
  "/unsubscribe",
];

function isPublicPage(pathname: string) {
  return !PRIVATE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

export const cacheHeadersMiddleware = createMiddleware({
  type: "request",
}).server(async ({ next }) => {
  const result = await next();
  try {
    const request = getRequest();
    const url = new URL(request.url);
    const accept = request.headers.get("accept") ?? "";

    if (
      request.method === "GET" &&
      accept.includes("text/html") &&
      isPublicPage(url.pathname) &&
      result.response.status === 200 &&
      !result.response.headers.has("cache-control")
    ) {
      result.response.headers.set(
        "cache-control",
        "public, max-age=0, s-maxage=600, stale-while-revalidate=86400",
      );
    }
  } catch {
    // never let header tuning break a response
  }
  return result;
});
